import React, { useState } from 'react';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Box from '@material-ui/core/Box';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import { makeStyles } from '@material-ui/core/styles';
import 'reactjs-popup/dist/index.css';
import Paper from '@material-ui/core/Paper';
import { Button, CircularProgress } from '@material-ui/core';
import { getViewURLNew } from '../../../utils/fileUploadHandler';
import convertTimestampToDate from '../../../utils/convertTimestampToDate';
import logger from '../../../utils/logger';
import { mappedCurrentActiveRole } from '../../../utils/roleMapping';

const useStyles = makeStyles({
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '10px',
  },
  viewButton: {
    background: '#52BE56',
    color: 'white',
    padding: '5px 10px',
  },
  nameTabs: {
    display: 'flex',
    flexDirection: 'column',
  },
  promptBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const inlineCheckIconStyle = {
  color: '#52BE56',
};

const nameBoxStyles = {
  display: 'flex',
  margin: '10px 0px 0px 8px',
  gap: '5px',
  alignItems: 'center',
};

const paperStyles = { padding: 10, marginTop: 10 };
const CancelledChequeUpload = ({
  truckerId,
  bankId,
  fileDetails,
  activeRole,
}) => {
  const {
    cancelled_cheque_file_path: isChequeAvailable,
    cancelled_cheque_uploaded_by: uploadedBy,
    cancelled_cheque_uploaded_at: uploadedAt,
  } = fileDetails || {};
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const viewFile = url => {
    window.open(url);
  };

  async function getCancelledChequeData() {
    setLoading(true);
    const viewURLBody = {
      file_type: 'trucker_cancelled_cheque',
      trucker_id: truckerId,
      bank_id: bankId,
      role: mappedCurrentActiveRole(activeRole),
    };
    getViewURLNew(viewURLBody)
      .then(result => {
        viewFile(result?.data?.file_details?.url);
        setLoading(false);
      })
      .catch(e => {
        logger.error('error', e);
        setLoading(false);
      });
  }

  return (
    <Paper elevation={1} style={paperStyles}>
      <Box>
        {!isChequeAvailable ? (
          <div>
            <p
              style={{
                margin: '8px',
                textAlign: 'left',
                fontSize: '20px',
                fontWeight: 400,
              }}
            >
              Cancelled Cheque
            </p>
            <p style={{ margin: '0 0 10px 8px' }}>No File Uploaded </p>
          </div>
        ) : (
          <div className={classes.headerWrapper}>
            <div className={classes.nameTabs}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <p
                  style={{
                    margin: '8px',
                    textAlign: 'left',
                    fontSize: '20px',
                    fontWeight: 400,
                  }}
                >
                  Cancelled Cheque
                </p>
                <CheckCircleIcon style={inlineCheckIconStyle} />
              </div>
              <div style={nameBoxStyles}>
                <p
                  style={{
                    fontWeight: 'bold',
                    fontSize: '12px',
                    margin: 0,
                  }}
                >
                  {uploadedBy}
                </p>
                <CircleIcon style={{ fontSize: '10px' }} />
                <p
                  style={{
                    color: '#a9a9a9',
                    fontSize: '10px',
                    margin: 0,
                  }}
                >
                  {convertTimestampToDate(uploadedAt)}
                </p>
              </div>
            </div>
            <Box>
              <div className={classes.promptBox}>
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  className={classes.viewButton}
                  onClick={() => getCancelledChequeData()}
                  startIcon={<VisibilityIcon />}
                  disabled={loading}
                >
                  View {loading && <CircularProgress size={8} />}
                </Button>
              </div>
            </Box>
          </div>
        )}
      </Box>
    </Paper>
  );
};

export default CancelledChequeUpload;
